import { collectionTagsToUiTags, trimToWord, styleHtmlForDisplay } from 'public/utils'
import wixData from 'wix-data'
import wixLocation from 'wix-location'
import wixWindow from 'wix-window'
import { session } from 'wix-storage'

import { BI_EVENTS } from 'public/biConsts'
import { sendBi } from 'public/biModule'

const BI_INPUTS = {
	category: 'showcase',
	referral_url: session.getItem('previousPageURL')
}

$w.onReady(function () {
	const featuredProjects = getFeaturedProjects().then(results => {
		bindFeaturedProjectsToUi(results)

		return results
	})

	const testimonials = getTestimonials().then(results => {
		bindTestimonialsToUi(results)

		return results
	})
    
    populateTagsInProjectsLst()

    if (wixWindow.rendering.env === 'browser') {
		// browser
	} else {
		return testimonials
	}

	handleShareProjectButton()
})


const getFeaturedProjects = async () => {
    const { items: featuredProjects } = await wixData.query('Showcase_Projects')
        .descending('featured')
        .limit(3)
        .find()

    return featuredProjects
    
}

const bindFeaturedProjectsToUi = (featuredProjects) => {
    featuredProjects.forEach((project, index) => {

        const uiIndex = index + 1

        const tags = collectionTagsToUiTags(project.tags)
        const truncatedTags = tags.slice(0,4)

        const storyWithoutHtml = project.story.replace(/<\/?[^>]+(>|$)/g, '')
        const trimmedStoryWithoutHtml = trimToWord(storyWithoutHtml, 120)
        
        $w(`#featuredMainImage${uiIndex}`).src = project.mainImage
        $w(`#featuredTitle${uiIndex}`).text = project.title
        $w(`#featuredTags${uiIndex}`).options = truncatedTags
        $w(`#featuredTags${uiIndex}`).disable()
        $w(`#featuredStory${uiIndex}`).text = trimmedStoryWithoutHtml
        $w(`#featuredLink${uiIndex}`).link = project['link-showcase-projects-title']
        $w(`#featuredLink${uiIndex}`).onClick(() => {
			sendBi(BI_EVENTS.ITEM_CLICKED, Object.assign({
				link_type: 'velo_project',
				page_name: $w('#page').title,
                related_link: project['link-showcase-projects-title'],
                topic: project.tags,
			}, BI_INPUTS))
        })

    })

    exposeFeaturedProjects()

}


const getTestimonials = async () => {

    const { items: testimonials } = await wixData.query('Showcase_Testimonials')
        .descending('displayed')
        .limit(3)
        .include('project')
        .find()

    return testimonials
    
}

const bindTestimonialsToUi = (testimonials) => {

    testimonials.forEach((testimonial, index) => {

        const project = testimonial.project

        const uiIndex = index + 1

        const quote = `“${testimonial.quote}”`
        
        $w(`#testimonialsMainImage${uiIndex}`).src = project.mainImage
        $w(`#testimonialsUserName${uiIndex}`).text = testimonial.userName
        $w(`#testimonialsQuote${uiIndex}`).text = quote
        $w(`#testimonialsUserImage${uiIndex}`).src = testimonial.userImage
        $w(`#testimonialsLink${uiIndex}`).text = project.link
        
        //wix auto generates links in text elements when it recognise a url
        $w(`#testimonialsLink${uiIndex}`).onClick(() => {
            //wixLocation.to(project.link)
			sendBi(BI_EVENTS.ITEM_CLICKED, Object.assign({
				link_type: 'website_project',
				page_name: $w('#page').title,
                related_link: project.link,
			}, BI_INPUTS))
        })

    })

    exposeTestimonials()
}

const populateTagsInProjectsLst = () => {
    $w('#projectsList').onItemReady( ($item, project, index) => {
        const tags = collectionTagsToUiTags(project.tags)
        try {
            $item('#tags').options = tags
        } catch (e) { console.log() }
        $item('#tags').disable()

        const linkedTitle = addLinkToProjectTitle(project.title, project['link-showcase-projects-title'])
        $item('#title').html = linkedTitle

        const trimmedDescription = trimToWord(project.description, 120)
        $item('#description').text = trimmedDescription

        //$item('#projectContainer, #mainImage, #title, #description, #tags').onClick(() => {
        $item('#projectContainer').onClick(() => {
			sendBi(BI_EVENTS.ITEM_CLICKED, Object.assign({
				link_type: 'velo_project',
				page_name: $w('#page').title,
                related_link: project['link-showcase-projects-title'],
                topic: project.tags,
			}, BI_INPUTS))
            wixLocation.to(project['link-showcase-projects-title'])
        })

        // for SEO purposes we add a link (<a> tag) to one of the elements
        // so Google's crawler can follow the link
        $item('#mainImage').link = project['link-showcase-projects-title']
        
    })
}

const handleShareProjectButton = () => {
	$w('#shareProjectButton').onClick(()=>{

		sendBi(BI_EVENTS.BANNER_CLICKED, Object.assign({
			banner_name: 'Showcase_submission',
			bannerLocationOnPage: 'bottom',
			banner_title: 'Have a robust project you’d like to share? We’d be happy to know more about it!'
		}, BI_INPUTS))

		wixWindow.openLightbox('Showcase - Share your project')

	})
}

const exposeFeaturedProjects = () => {
    $w('#featuredProjects').show()
    $w('#featuredProjectsLoadingPlaceholder').hide()
}

const exposeTestimonials = () => {
    $w('#testimonials').show()
}

const addLinkToProjectTitle = (text, link) => {
    const linkedText = `<h3 class="font_2" style="font-size:20px; line-height:1.4em;"><a href="${link}">${text}</a></h3>`
    return linkedText
}